var parse=require('../parse/index.js');/**
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the month
 *
 * @example
 * // Which month is 29 February 2012?
 * var result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */function getMonth(dirtyDate){var date=parse(dirtyDate);var month=date.getMonth();return month;}module.exports=getMonth;